<template>
    <div>
        <div class="flex h-screen overflow-hidden bg-gray-100">
            <!-- @keydown.window.escape="sidebarOpen = false" -->
            <!-- Off-canvas menu for mobile -->
            <div v-show="sidebarOpen" class="md:hidden">
                <div
                    @click="sidebarOpen = false"
                    v-show="sidebarOpen"
                    x-transition:enter-start="opacity-0"
                    x-transition:enter-end="opacity-100"
                    x-transition:leave-start="opacity-100"
                    x-transition:leave-end="opacity-0"
                    class="fixed inset-0 z-30 transition-opacity duration-300 ease-linear"
                >
                    <div class="absolute inset-0 bg-gray-600 opacity-75"></div>
                </div>
                <div class="fixed inset-0 z-40 flex">
                    <div
                        v-show="sidebarOpen"
                        x-transition:enter-start="-translate-x-full"
                        x-transition:enter-end="translate-x-0"
                        x-transition:leave-start="translate-x-0"
                        x-transition:leave-end="-translate-x-full"
                        class="flex flex-col flex-1 w-full max-w-xs pt-5 pb-4 duration-300 ease-in-out transform bg-gray-800"
                    >
                        <div class="absolute top-0 right-0 p-1 -mr-14">
                            <button
                                v-show="sidebarOpen"
                                class="flex items-center justify-center w-12 h-12 rounded-full focus:outline-none focus:bg-gray-600"
                            >
                                <svg
                                    @click="sidebarOpen = false"
                                    class="w-6 h-6 text-white"
                                    stroke="currentColor"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M6 18L18 6M6 6l12 12"
                                    />
                                </svg>
                            </button>
                        </div>
                        <div class="flex items-center flex-shrink-0 px-4">
                            <h1
                                class="w-auto h-8 px-4 text-3xl font-black text-white sm:h-10"
                            >
                                CRI<span class="text-2xl font-normal"
                                    >BusinessPlan</span
                                >
                            </h1>
                        </div>
                        <div class="flex-1 h-0 mt-5 overflow-y-auto">
                            <nav class="px-2">
                                <a
                                    href="#"
                                    class="flex items-center px-2 py-2 text-base font-medium leading-6 text-white transition duration-150 ease-in-out bg-gray-900 rounded-md group focus:outline-none focus:bg-gray-700"
                                >
                                    <svg
                                        class="w-6 h-6 mr-4 text-gray-300 transition duration-150 ease-in-out group-hover:text-gray-300 group-focus:text-gray-300"
                                        stroke="currentColor"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M3 12l9-9 9 9M5 10v10a1 1 0 001 1h3a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1h3a1 1 0 001-1V10M9 21h6"
                                        />
                                    </svg>
                                    BP validé
                                </a>
                                <a
                                    href="#"
                                    class="flex items-center px-2 py-2 text-base font-medium leading-6 text-white transition duration-150 ease-in-out bg-gray-900 rounded-md group focus:outline-none focus:bg-gray-700"
                                >
                                    <svg
                                        class="w-6 h-6 mr-4 text-gray-300 transition duration-150 ease-in-out group-hover:text-gray-300 group-focus:text-gray-300"
                                        stroke="currentColor"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M3 12l9-9 9 9M5 10v10a1 1 0 001 1h3a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1h3a1 1 0 001-1V10M9 21h6"
                                        />
                                    </svg>
                                    BP en cours de validation
                                </a>
                                <a
                                    href="#"
                                    class="flex items-center px-2 py-2 text-base font-medium leading-6 text-white transition duration-150 ease-in-out bg-gray-900 rounded-md group focus:outline-none focus:bg-gray-700"
                                >
                                    <svg
                                        class="w-6 h-6 mr-4 text-gray-300 transition duration-150 ease-in-out group-hover:text-gray-300 group-focus:text-gray-300"
                                        stroke="currentColor"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M3 12l9-9 9 9M5 10v10a1 1 0 001 1h3a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1h3a1 1 0 001-1V10M9 21h6"
                                        />
                                    </svg>
                                    Analyse des BP
                                </a>
                            </nav>
                        </div>
                    </div>
                    <div class="flex-shrink-0 w-14">
                        <!-- Force sidebar to shrink to fit close icon -->
                    </div>
                </div>
            </div>

            <!-- Static sidebar for desktop -->
            <div class="hidden md:flex md:flex-shrink-0">
                <div class="flex flex-col w-64">
                    <div
                        class="flex items-center flex-shrink-0 h-16 px-4 bg-gray-900"
                    >
                        <h1
                            class="w-auto h-8 px-4 text-3xl font-black text-white sm:h-10"
                        >
                            CRI<span class="text-2xl font-normal"
                                >BusinessPlan</span
                            >
                        </h1>
                    </div>
                    <div class="flex flex-col flex-1 h-0 overflow-y-auto">
                        <!-- Sidebar component, swap this element with another sidebar if you like -->
                        <nav class="flex-1 px-2 py-4 bg-gray-800">
                            <router-link
                                :to="{ name: 'validated_bpi' }"
                                class="flex items-center px-2 py-2 text-sm font-medium leading-5 text-white transition duration-150 ease-in-out rounded-md group focus:outline-none focus:bg-gray-700"
                                :class="{
                                    'bg-gray-800': !activeRoute(
                                        'validated_bpi'
                                    ),
                                    'bg-gray-900': activeRoute('validated_bpi')
                                }"
                            >
                                <svg
                                    class="w-6 h-6 mr-3 text-gray-300 transition duration-150 ease-in-out group-hover:text-gray-300 group-focus:text-gray-300"
                                    stroke="currentColor"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M3 12l9-9 9 9M5 10v10a1 1 0 001 1h3a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1h3a1 1 0 001-1V10M9 21h6"
                                    />
                                </svg>
                                BP validé
                            </router-link>

                            <router-link
                                :to="{ name: 'bpi_in_process' }"
                                class="flex items-center px-2 py-2 text-sm font-medium leading-5 text-white transition duration-150 ease-in-out rounded-md group focus:outline-none focus:bg-gray-700"
                                :class="{
                                    'bg-gray-800': !activeRoute(
                                        'bpi_in_process'
                                    ),
                                    'bg-gray-900': activeRoute('bpi_in_process')
                                }"
                            >
                                <svg
                                    class="w-6 h-6 mr-3 text-gray-300 transition duration-150 ease-in-out group-hover:text-gray-300 group-focus:text-gray-300"
                                    stroke="currentColor"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M3 12l9-9 9 9M5 10v10a1 1 0 001 1h3a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1h3a1 1 0 001-1V10M9 21h6"
                                    />
                                </svg>
                                BP en cours de validation
                            </router-link>
                            <router-link
                                :to="{ name: 'bpi_analytics' }"
                                class="flex items-center px-2 py-2 text-sm font-medium leading-5 text-white transition duration-150 ease-in-out rounded-md group focus:outline-none focus:bg-gray-700"
                                :class="{
                                    'bg-gray-800': !activeRoute(
                                        'bpi_analytics'
                                    ),
                                    'bg-gray-900': activeRoute('bpi_analytics')
                                }"
                            >
                                <svg
                                    class="w-6 h-6 mr-3 text-gray-300 transition duration-150 ease-in-out group-hover:text-gray-300 group-focus:text-gray-300"
                                    stroke="currentColor"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M3 12l9-9 9 9M5 10v10a1 1 0 001 1h3a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1h3a1 1 0 001-1V10M9 21h6"
                                    />
                                </svg>
                                Analyse des BP
                            </router-link>
                        </nav>
                    </div>
                </div>
            </div>
            <div class="flex flex-col flex-1 w-0 overflow-hidden">
                <div
                    class="relative z-10 flex flex-shrink-0 h-16 bg-white shadow"
                >
                    <button
                        class="px-4 text-gray-500 border-r border-gray-200 focus:outline-none focus:bg-gray-100 focus:text-gray-600 md:hidden"
                    >
                        <svg
                            @click.stop="sidebarOpen = true"
                            class="w-6 h-6"
                            stroke="currentColor"
                            fill="none"
                            viewBox="0 0 24 24"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M4 6h16M4 12h16M4 18h7"
                            />
                        </svg>
                    </button>
                    <div class="flex justify-between flex-1 px-4">
                        <div class="flex flex-1"></div>
                        <div class="flex items-center ml-4 md:ml-6">
                            <!-- @click.away="open = false" -->
                            <div class="relative ml-3" x-data="{ open: false }">
                                <div>
                                    <button
                                        @click="open = !open"
                                        class="flex items-center max-w-xs text-sm rounded-full focus:outline-none "
                                    >
                                        <span
                                            class="inline-block w-8 h-8 overflow-hidden bg-gray-100 rounded-full"
                                        >
                                            <svg
                                                class="w-full h-full text-gray-300"
                                                fill="currentColor"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z"
                                                />
                                            </svg>
                                        </span>
                                    </button>
                                </div>
                                <transition
                                    enter-active-class="transition duration-100 ease-out transform"
                                    enter-class="scale-95 opacity-0"
                                    enter-to-class="scale-100 opacity-100"
                                    leave-active-class="transition duration-75 ease-in transform"
                                    leave-class="scale-100 opacity-100"
                                    leave-to-class="scale-95 opacity-0"
                                >
                                    <div
                                        v-show="open"
                                        class="absolute right-0 w-48 mt-2 origin-top-right rounded-md shadow-lg"
                                    >
                                        <div
                                            class="py-1 bg-white rounded-md shadow-xs "
                                        >
                                            <a
                                                @click="SignOut"
                                                class="block px-4 py-2 text-sm text-gray-700 transition duration-150 ease-in-out cursor-pointer hover:bg-gray-100"
                                                >Sign out</a
                                            >
                                        </div>
                                    </div>
                                </transition>
                            </div>
                        </div>
                    </div>
                </div>

                <base-notifications
                    class="z-10"
                    :show="notification.show"
                    v-on:close="closeNotification"
                    :error="notification.error"
                >
                    <template v-slot:title>{{ notification.title }}</template>
                    <template v-slot:content>
                        {{ notification.content }}
                    </template>
                </base-notifications>
                <main
                    class="relative flex-1 py-6 mx-auto overflow-auto w-95 focus:outline-none "
                    tabindex="0"
                    ref="main"
                >
                    <router-view
                        v-on:fetching-data="loading = false"
                        v-on:showNotification="showNotification"
                    ></router-view>
                </main>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            open: false,
            sidebarOpen: false,
            notification: {
                show: false,
                error: false,
                content: "",
                title: ""
            },
            loading: true
        };
    },
    mounted() {
        if (this.$route.name === "admin") {
            this.$router.push({ name: "validated_bpi" });
        }
    },
    methods: {
        SignOut() {
            this.$store.dispatch("Auth/signOut");
        },
        showNotification(notification) {
            this.notification.content = notification.content;
            this.notification.title = notification.title;
            this.notification.show = true;
            setTimeout(() => (this.notification.show = false), 4000);
        },
        closeNotification() {
            this.notification = {
                show: false,
                error: false,
                content: "",
                title: ""
            };
        }
    },
    computed: {
        activeRoute() {
            return route => {
                if (this.$route.name === route) return true;
                return false;
            };
        }
    }
};
</script>

<style></style>
